import React, { useState, useRef, useContext } from 'react';
import EmpresaContext from "../../../contexts/Empresa";
import { AxiosResponse } from 'axios';
import { useHistory } from "react-router-dom";
import api from "../../../services/api";
//@ts-ignore
import NotificationAlert from "react-notification-alert";
import Filters from './Filters'

import { Nota } from '../../../entities/Mentoring';

import Table from './Table';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import SimpleHeader from '../../../components/Headers/SimpleHeader'

const Notas: React.FC = ({ }) => {

  const history = useHistory()
  const { empresaSelecionada } = useContext(EmpresaContext)
  const [loading, setLoading] = useState(false)
  const [alert, setAlert] = useState(null)
  const [notas, setNotas] = useState(new Array<Nota>())
  const [pageProperties, setPageProperties] = useState({
    total: "0",
    perPage: 10,
    page: 1,
    lastPage: 1,
    loading: false
  })
  const [lastSearch, setLastSearch] = useState({})
  const notificationAlert = useRef<NotificationAlert>(null);

  function notify(type: string, msg: string) {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span data-notify="message">
            {msg}
          </span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 7
    };
    if(notificationAlert?.current) {
      notificationAlert.current.notificationAlert(options);
    }
  };

  function handleNewNota(e: React.MouseEvent) {
    e.preventDefault();
    history.push('notas/new')
  }

  async function updatePageProperties(response: AxiosResponse) {
    const { total, perPage, page, lastPage } = await response.data
    setPageProperties({
      total,
      perPage,
      page,
      lastPage,
      loading: false,
    })
  }

  async function loadNotas(page = 1,
    limit = 10,
    sortField = "tema",
    sortOrder = "asc",
    filters = lastSearch) {
    try {
      setPageProperties({
        ...pageProperties,
        loading: true
      })
      const response = await api.get(`mentoring/empresas/${empresaSelecionada?.id}/notas/`, {
        params: {
          page,
          limit,
          sortField,
          sortOrder,
          ...filters
        }
      })
      setNotas(response.data.data.map((e:any)=>{
        
        // e.data_anotacao = new Date(e.data_anotacao).toLocaleString()
        return e
      }))
      await updatePageProperties(response)
    } catch (err) {
      //@ts-ignore
      console.log(err.response)
      notify('danger', 'Houve um problema ao carregar as notas.');
    }
  }

  async function handleTableChange(type: string, sortProperties: { page: number, sizePerPage: number, sortField: string, sortOrder: string }): Promise<void> {
    try {
      await loadNotas(
        sortProperties.page == 0 ? 1 : sortProperties.page,
        sortProperties.sizePerPage,
        sortProperties.sortField,
        sortProperties.sortOrder)
    } catch (error) {
      notify('danger', 'Houve um problema ao carregar as notas.');
    }
  }


  return (
    <>
      {alert}
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <SimpleHeader name="Listagem de Notas" parentName="Notas" />
      <div className="w-100">
        <Row>
          <Col>
            <Card>
              <CardHeader
                style={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 1,
                }}>
                <Filters
                  title={<h1>Notas</h1>}
                  data={notas}
                  notify={notify}
                  load={(filters: object) => {
                    setLastSearch(filters)
                    loadNotas(
                      1,
                      10,
                      "tema",
                      "asc",
                      filters)
                  }}
                />
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs='12'>
                    <span >
                      <Button
                        color="primary"
                        type="button"
                        onClick={handleNewNota}
                        size="sm">
                        <span className="btn-inner--icon">
                          <i className="ni ni-fat-add" />
                        </span>
                        Nova Nota
                        </Button>
                    </span>
                  </Col>

                  <Col>
                    <Table
                      notas={notas || []}
                      notify={notify}
                      onTableChange={handleTableChange}
                      pageProperties={pageProperties}
                      loading={loading}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default Notas;